export const api = {
  queryDeviceList: '/bms/device/queryDeviceListByType.json', //根据区域查询设备
  queryControlTaskCamera: '/vas/controltask/queryControlTaskCamera.json', //查询摄像机
  startControlTask: '/vas/controltask/startControlTask.json', //启用布控
  stopControlTask: '/vas/controltask/stopControlTask.json', //停用布控
  queryFaceGroupByType: '/vas/faceGroup/queryFaceGroupByTypeApi.json', //查询人脸名单组
  queryVehicleGroupByType: '/vas/vehicleRepositories/queryVehicleGroupByType.json', //查询车辆名单组
  addControlTask: '/vas/controltask/addControlTask.json', //新增布控
  updateControlTask: '/vas/controltask/updateControlTask.json', //修改布控
  deleteControlTask: '/vas/controltask/deleteControlTask.json', //删除布控
  queryControlTask: '/vas/controltask/queryControlTask.json', //查询布控任务列表
  exportControlTask: '/vas/controltask/exportControlTask.json', //导出布控任务列表
  queryControlGroupTask: 'vas/controltask/queryControlGroupTask.json', //查询布控任务组列表
  queryControlTaskDetail: '/vas/controltask/queryControlTaskDetail.json', //查询布控任务详情
  queryControlTaskRecord: '/vas/controltask/queryControlTaskRecord.json', //查询布控任务记录列表
  queryControlTaskRecordDetail: 'vas/controltask/queryControlTaskRecordDetail.json', //查询布控任务记录列表详情
  queryResourcePoolUsage: '/vas/imesresourcepool/queryResourcePoolUsage.json', //查询资源池  
  queryControlGroupTaskDetail: '/vas/controltask/queryControlGroupTaskDetail.json', //查询布控组任务详情  
  updateControlGroupTask: '/vas/controltask/updateControlGroupTask.json', //修改布控组 
  queryControlSubmitDataList: '/vas/controltask/queryControlSubmitDataList.json',//查看识别记录
}